module.exports = __webpack_public_path__ + "img/ic-circle-close.2a246918.svg";